export const approvalRoot = {
    "formatVersion": 1,
    "rootId": "hephesapla.everyday-health.approval.local-exact46",
    "sequence": 4,
    "previousRootSha256": "8e56a71d3b31c80274e220e197b6d2f20118beaf422fc028e2461c65d81f631d",
    "keyId": "everyday-health-local-test-ed25519-2026-v4-profit-margin-v2",
    "receiptId": "everyday-health-contract-receipt-2026-v3-profit-margin-v2-local-exact46",
    "receiptCanonicalSha256": "dab986a7bd487ca6041698309286ebf0d1e43dbed1f6dd53ed77b4f6cc2d0058",
    "oracleId": "everyday-health-official-2026-v2-profit-margin",
    "oracleCanonicalSha256": "704d7086352ae2550e13692a86355c0fb8ea5024b64524558f423432540ca06f",
    "signatureBase64": "8+62wZsWplUE+FBUCBnY05wMCang6PjgNu84Md7GF0aYwUx7PhKWgNIL7j/JgcVvlqSYTnFvJsQQYYysoRnDDA=="
};
